import { CURRENCY, DiscountTypesEnum } from "helpers/constants";
import { DiscountWithActivities } from "../DiscountList";
import { Discount } from "backend/api/discounts";

export const getDiscountUnit = (
  discount: DiscountWithActivities | Discount,
) => {
  return discount
    ? discount.discountType === DiscountTypesEnum.PERCENTAGE
      ? "%"
      : CURRENCY
    : "";
};
